import styled, { css } from 'styled-components';
import { ChevronIcon } from '@sainsburys-tech/bolt-icons';
var Nav = styled.nav.withConfig({
  displayName: "Breadcrumbstyles__Nav",
  componentId: "alke4b-0"
})(["list-style-type:none;padding:5px 0 5px 15px;font-family:", ";font-size:", ";border-bottom:1px solid ", ";@media (min-width:", "){padding:10px 0 10px 15px;margin-bottom:0;border-bottom:none;padding-left:0;padding-right:0;}", ""], function (props) {
  return props.theme.font.family.brand;
}, function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
}, function (props) {
  return props.isLargeOnly && css(["margin-bottom:0;border-bottom:none;padding-left:0;padding-right:0;"]);
});
var Chevron = styled(ChevronIcon).withConfig({
  displayName: "Breadcrumbstyles__Chevron",
  componentId: "alke4b-1"
})(["width:calc(1em + 2px);fill:", ";margin-right:4px;flex-shrink:0;"], function (props) {
  return props.theme.color.palette['brand-1'];
});
var ToggleButton = styled.button.withConfig({
  displayName: "Breadcrumbstyles__ToggleButton",
  componentId: "alke4b-2"
})(["width:55px;height:2.0625rem;border:none;background-color:transparent;border-left:1px solid ", ";color:", ";padding:3px 0 0;"], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.color.palette['brand-1'];
});
var Item = styled.li.withConfig({
  displayName: "Breadcrumbstyles__Item",
  componentId: "alke4b-3"
})(["transition:max-height 0.2s ease;max-height:0;overflow:hidden;padding-right:8px;min-width:100%;width:100%;max-width:80%;@media (min-width:", "){max-height:none;min-width:auto;min-width:initial;overflow:inherit;width:auto;}", " ", " ", " ", " ", " ", ""], function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
}, function (props) {
  return props.isOpen && css(["max-height:4em;"]);
}, function (props) {
  return props.isSingle && css(["transition:none;min-height:35px;"]);
}, function (props) {
  return props.isLast && css(["display:block;max-height:none;float:left;min-width:calc(100% - 55px);width:auto;@media (min-width:", "){float:none;min-width:auto;min-width:initial;}"], props.theme.size.breakpoint['min-width'].sm);
}, function (props) {
  return props.isLargeOnly && css(["max-height:none;min-width:auto;min-width:initial;overflow:inherit;width:auto;"]);
}, function (props) {
  return props.isLast && props.isLargeOnly && css(["float:none;min-width:auto;min-width:initial;"]);
}, function (props) {
  return props.isActive && css(["color:", ";&:hover::before{color:", ";}"], props.theme.color.monochrome.dark, props.theme.color.palette['brand-1']);
});
var Link = styled.a.withConfig({
  displayName: "Breadcrumbstyles__Link",
  componentId: "alke4b-4"
})(["&:hover{color:", ";text-decoration:none;", "{fill:currentColor;}}&:active,&:focus{color:", ";outline-offset:4px;text-decoration:none;}"], function (props) {
  return props.theme.color.monochrome.dark;
}, Chevron, function (props) {
  return props.theme.color.palette['brand-1'];
});
var Span = styled.span.withConfig({
  displayName: "Breadcrumbstyles__Span",
  componentId: "alke4b-5"
})(["&:hover{color:", ";text-decoration:none;", "{fill:currentColor;}}&:active,&:focus{color:", ";outline-offset:4px;text-decoration:none;}"], function (props) {
  return props.theme.color.monochrome.dark;
}, Chevron, function (props) {
  return props.theme.color.palette['brand-1'];
});
export { Nav, Chevron, Item, ToggleButton, Link, Span };